var nurseslounge_myDashboard_activity = {
    init:function($params){
        $(window).nurseslounge_myDashboard_wall($params);
        //nurseslounge_myDashboard_activity.wall_articles();
        //nurseslounge_myDashboard_activity.wall_album();
        nurseslounge_myDashboard_activity.lounge_follow_request(function($chtml){
            nurseslounge_myDashboard_activity.lounge_follow_container($chtml);
        });
        nurseslounge_myDashboard_activity.connect_with(function($config){
            nurseslounge_myDashboard_myProfile.connect_engine($config);
        });
        nurseslounge_myDashboard_activity.banners_location(function($config){
            nurseslounge_myDashboard_myProfile.banners_engine($config);
        });
        nurseslounge_myDashboard_activity.become_a_thought_leader(function(){
            nurseslounge_myDashboard_thoughtLeadersForm.open_modal($params);
        });
        nurseslounge_myDashboard_activity.invite_colleagues(function($config){
            nurseslounge_myDashboard_myProfile.invite_colleagues_engine($config);
        });
        nurseslounge_myDashboard_myProfile.profile_is_complete($params, true);
        nurseslounge_myDashboard_activity.task_list_container(function($container){
            nurseslounge_myDashboard_myProfile.task_list($container, $params);
        });
        nurseslounge_myDashboard_activity.preview_profile_container(function($container){
            nurseslounge_myDashboard_myProfile.preview_profile($container, $params);
        });
        nurseslounge_myDashboard_activity.lounge_rate_list($params);
        nurseslounge_myDashboard_activity.notification_link();
        nurseslounge_myDashboard_activity.lounge_ads_location(function($config){
            nurseslounge_lounge_overview.lounge_ads_engine($config);
        });
        nurseslounge_myDashboard_activity.spotlight_container(function($container){
            nurseslounge_myDashboard_myProfile.spotlight($container, $params);
        });
    },
    //Lounge Follow
    lounge_follow_request:function(cback){
        $.ajax({
            method: 'POST',
            url: '/myDashboard/activity/lounge/follow/get',
            data: {
                user_id: libs.memoryGet('user_id')
            },
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                if ($data.status == 'success') {
                    var $chtml = nurseslounge_myDashboard_activity.lounge_follow_html($data.data.lounge_follow);
                    cback($chtml);
                }
            }
        });
    },
    lounge_follow_html:function($loungeFollow){
        var $chtml = '';
        $.each($loungeFollow, function($i, $v){
            var $img = $v.logo_root_lounge;
            $chtml += '' +
                '<div class="card-lounge text-center py-4 position-relative">' +
                '   <div class="profile-img img-objectfit">' +
                '       <a href="'+$v.link+'" target="_self" class="stretched-link" data-key="'+$v.key+'" data-public_link="'+$v.public_link+'">' +
                '           <img src="'+$img+'?resize=100" alt="education">' +
                '       </a>' +
                '   </div>' +
                '   <div class="list-info align-self-center">' +
                '       <h4>' +
                '           <a href="'+$v.link+'" target="_self" class="stretched-link" data-key="'+$v.key+'" data-public_link="'+$v.public_link+'">'+$v.name+'</a>' +
                '       </h4>' +
                '   </div>'+
                '</div>';
        });
        if($chtml == ''){
            $chtml = nurseslounge_myDashboard_activity.lounge_search_html($chtml);
        }
        return $chtml;
    },
    lounge_search_html:function($chtml){
        $chtml += '' +
            '<div class="card-lounge text-center py-4 position-relative">' +
            '   <div class="list-info">' +
            '       <h4 class="d-flex h-100 align-items-center justify-content-center">' +
            '           <a href="/lounges/schools" target="_self" class="stretched-link link-color">' +
            '               Search Lounges to Follow' +
            '           </a>' +
            '       </h4>' +
            '   </div>' +
            '</div>';
        return $chtml;
    },
    lounge_follow_container:function($chtml){
        libs.checkImageLoad($($chtml).find('img'), function(){
            $("#nurseslounge-home-activity .nurseslounge-home-activity-right .follow-lounges").html($chtml);
        });
    },
    //Connect With
    connect_with:function(cback){
        cback({
            'connect':$("#nurseslounge-home-activity .nurseslounge-home-activity-left .connect-with")
        });
    },
    //Banners Location
    banners_location:function(cback){
        cback({
            'banners':$("#nurseslounge-home-activity .nurseslounge-home-activity-right .banners")
        });
    },
    lounge_ads_location:function(cback){
        cback({
            'ads':$("#nurseslounge-home-activity .nurseslounge-home-activity-right .lounge-ads")
        });
    },
    //Become a Thought Leader
    become_a_thought_leader:function(cback){
        $("#nurseslounge-home-activity .nurseslounge-home-activity-right .complete-form-thought-leader").unbind().click(function(){
           cback();
        });
    },
    //Invite Colleagues
    invite_colleagues:function(cback){
        cback({
            'colleagues':$("#nurseslounge-home-activity .nurseslounge-home-activity-right .send-invite")
        });
    },
    //Task List Container
    task_list_container:function(cback){
        var $container = $("#nurseslounge-home-activity .nurseslounge-home-activity-right");
        cback($container);
    },
    //Preview Profile
    preview_profile_container:function(cback){
        var $container = $("#nurseslounge-home-activity .nurseslounge-home-activity-right");
        cback($container);
    },
    //Rate Lounge List
    lounge_rate_list:function($params){
        var $loungeActivityLeft = $("#nurseslounge-home-activity .nurseslounge-home-activity-left");
        var $loungeList = $loungeActivityLeft.find(".lounges-list:first");
        var $loungeListPreview = nurseslounge_myDashboard_activity.lounge_preview();
        var $resultInfo = $loungeActivityLeft.find(".result-info-count:first");
        var $resultPreview = '&nbsp;';
        var $paginationNav = $loungeActivityLeft.find('.pagination-nav');
        var $paginationNavPreview = '&nbsp;';
        $resultInfo.addClass('nurseslounge-lounge-degrees-preload').html($resultPreview);
        $paginationNav.addClass('nurseslounge-lounge-degrees-preload').html($paginationNavPreview);
        $loungeList.html($loungeListPreview).promise().done(function(){
            nurseslounge_myDashboard_activity.lounge_pagination($params);
        });
    },
    lounge_preview:function(){
        var $chtml = '';
        for(var $i=1; $i<=10; $i++){
            $chtml+= '' +
                '<li class="shadow p-3 mb-3 bg-white rounded preview">' +
                '    <div class="row open-lounge">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-4 nurseslounge-lounge-rate-preload">' +
                '                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100 nurseslounge-lounge-rate-preload">' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-md-auto text-center text-sm-right align-self-center nurseslounge-lounge-rate-preload">' +
                '                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '        </div>' +
                '    </div>' +
                '</li>';
        }
        return $chtml;
    },
    lounge_pagination:function($params){
        var $reload;
        var $loaded = false;
        var $afterFirstPagination = false;
        var $loungeActivityLeft = $("#nurseslounge-home-activity .nurseslounge-home-activity-left");
        var $loungeList = $loungeActivityLeft.find('.lounges-list:first');
        var $paginationNav = $loungeActivityLeft.find('.pagination-nav');
        var $previewHeight = $loungeActivityLeft.find('.lounges-list .preview:first').innerHeight();
        var $degreeHeight = $loungeList.innerHeight();
        var $pageSize = Math.round(($degreeHeight/$previewHeight));
        var $resultInfo = $loungeActivityLeft.find(".result-info-count:first");
        var $saveParams = $params;
        var $paginationObj;
        try{
            $paginationObj = libs.memoryGet('lounge_rate_pagination');
            if($paginationObj){
                $paginationObj.pagination('destroy');
            }
        }catch ($e) {
        }
        try {
            $paginationObj = $paginationNav.pagination({
                pageSize: $pageSize,
                showPageNumbers: true,
                showPrevious: true,
                showNext: true,
                showNavigator: true,
                showFirstOnEllipsisShow: true,
                showLastOnEllipsisShow: true,
                dataSource: window.location.protocol + '//' + window.location.hostname + "/myDashboard/activity/loungeRate/get",
                locator: 'data.lounges',
                ajax: {
                    method: "POST",
                    cache: false,
                    dataType: "json",
                    data: $params,
                    beforeSend: function () {
                        $loungeList.html(nurseslounge_myDashboard_activity.lounge_preview());
                    },
                    complete: function ($data) {
                        libs.expire($data.responseJSON);
                    }
                },
                totalNumberLocator: function ($data) {
                    return $data.data.total;
                },
                callback: function ($data, $pagination) {
                    $loaded = true;
                    if ($loungeList.length > 0 && $loungeList.offset().top > 0 && $afterFirstPagination) {
                        $('html, body').animate({scrollTop: $loungeList.offset().top - 100});
                    } else {
                        $afterFirstPagination = true;
                    }
                    var $pageNumber = $pagination.pageNumber;
                    var $pageSize = $pagination.pageSize;
                    var $totalNumber = $pagination.totalNumber;
                    var $first = $totalNumber > 0 ? (($pageNumber - 1) * $pageSize) + 1 : 0;
                    var $last = $totalNumber > 0 ? ($first + $data.length - 1) : 0;
                    $paginationNav.removeClass('nurseslounge-lounge-rate-preload');
                    $resultInfo.removeClass('nurseslounge-lounge-rate-preload').html('<strong>Showing ' + $first + ' - ' + $last + ' of ' + $totalNumber + '</strong> results for <span class="link-color">Degrees</span>');
                    var $chtml = nurseslounge_myDashboard_activity.lounge_item_html($data);
                    libs.checkImageLoad($($chtml).find('img'), function () {
                        $loungeList.html('').html($chtml).promise().done(function () {
                            if ($chtml == '') {
                                $loungeActivityLeft.find(".lounge-rate-wrapper").remove();
                            } else {
                                nurseslounge_myDashboard_activity.lounge_item_events($saveParams);
                            }
                        });
                    });
                }
            });
            libs.memorySave('lounge_rate_pagination', $paginationObj);
            $reload = setTimeout(function(){
                if(!$loaded){
                    nurseslounge_myDashboard_activity.lounge_pagination($params);
                }else{
                    clearTimeout($reload);
                }
            }, 10000);
        }catch ($e) {

        }
    },
    lounge_item_html:function($lounges){
        var $chtml = '';
        $.each($lounges, function($i, $v){
            var $img = $v.logo_root_lounge;
            $chtml+='' +
                '<li class="shadow p-3 mb-3 bg-white rounded lounge-item" data-key="'+$v.key+'" data-link="'+$v.link+'">' +
                '    <div class="row open-lounge">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-4">' +
                '                    <img src="'+$img+'?resize=80" alt="lounge">' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100">' +
                '                    <h4 class="lounge-name">' +
                '                        <a href="javascript:void(0)">'+$v.name+'</a>' +
                '                    </h4>' +
                nurseslounge_myDashboard_activity.add_stars($v.rating) +
                '                </div>' +
                '            </div>' +
                '        </div>'+
                '        <div class="col-md-auto text-center text-sm-right align-self-center">';
                //TODO::Coins
                if (libs.memoryGet('env') != 'production'){
                    $chtml += '' +
                        '<div class="col-2 offset-10 open-rate">' +
                        '   <div class="coin alternate">' +
                        '       <div class="front"></div>' +
                        '       <div class="front_b"></div>' +
                        '       <div class="back"></div>' +
                        '       <div class="back_b"></div>' +
                        '   </div>'+
                        '</div>';
                }
            if($v.lounge_type_id == 1){
                $chtml+='' +
                    '<div class="col-12 mr-0 pr-0 mt-4">' +
                    '   <button type="button" class="btn btn-save btnAnimate open-rate">Rate this employer</button>' +
                    '</div>';
            }
            if($v.lounge_type_id == 2){
                $chtml+='' +
                    '<div class="col-12 mr-0 pr-0 mt-4">' +
                    '   <button type="button" class="btn btn-save btnAnimate open-rate">Rate this school</button>' +
                    '</div>';
            }
            $chtml+='' +
                '        </div>';
                '    </div>' +
                '</li>';
        });
        return $chtml;
    },
    add_stars:function($rating){
        var $chtml = '';
        for(var $i=1; $i<=5; $i++) {
            var $star = $rating - $i;
            var $offsetOn;
            var $offsetOff;
            var $unique = libs.getUniqueId();
            if($star >= 0){
                $offsetOn = 100;
                $offsetOff = 0;
            }else if($star < 0 && $star > -1){
                $star = ($star * -1);
                $offsetOff = ($star * 100);
                $offsetOn = (100 - $offsetOff);
            }else{
                $offsetOn = 0;
                $offsetOff = 100;
            }
            $chtml += '' +
                '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="url(#percent'+$unique+')">' +
                '   <defs>' +
                '       <linearGradient id="percent'+$unique+'">';
            if($offsetOn > 0) {
                $chtml += '' +
                    '<stop offset="' + $offsetOn + '%" stop-color="#FDA630" stop-opacity="1"></stop>';
            }
            if($offsetOff > 0){
                $chtml += '' +
                    '<stop offset="'+$offsetOff+'%" stop-color="#E2E2E9" stop-opacity="1"></stop>';
            }
            $chtml += '' +
                '       </linearGradient>' +
                '   </defs>' +
                '   <polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566"></polygon>' +
                '</svg>';
        }
        return $chtml;
    },
    lounge_item_events:function($params){
        var $loungeActivityLeft = $("#nurseslounge-home-activity .nurseslounge-home-activity-left");
        var $loungeList = $loungeActivityLeft.find('.lounges-list:first');
        $loungeList.find(".lounge-item").unbind().click(function($e){
            var $link = $(this).data('link');
            window.open($link, '_self');
        });
        $loungeList.find(".open-rate").unbind().click(function($e){
            $e.stopPropagation();
            var $key = $(this).parents('.lounge-item:first').data('key');
            $params = $.extend({}, $params, {key:$key});
            nurseslounge_myDashboard_myProfile.lounge_review_get_request($params, function($data){
                var $typeId = $data.data.lounge.lounge_type_id;
                var $link = $data.data.lounge.link;
                nurseslounge_lounge_overview.information_review($typeId, $params, $data, function(){
                    router.navigate($link+'/ratingReviews',true);
                    $("#nurseslounge-lounge-information-review-modal").modal('hide');
                });
            });
        });
    },
    //Notification Link
    notification_link:function(){
        var $exist = nurseslounge_myDashboard_accountSettings.readCookie('myDashboardActivityLeftWrapper');
        if($exist == 1){
            $("#myDashboardActivityLeft-wrapper").remove();
        }else{
            $("#myDashboardActivityLeft-wrapper .close").unbind().click(function(){
                $("#myDashboardActivityLeft-wrapper").remove();
                nurseslounge_myDashboard_accountSettings.createCookie('myDashboardActivityLeftWrapper',1,100);
            });
        }
    },
    //Spotlight
    spotlight_container:function(cback){
        var $container = $("#nurseslounge-home-activity .nurseslounge-home-activity-left .spotlight-wrapper");
        cback($container);
    },
};
